export const handleBrand = (brand: string, theme: string) => {
  switch (brand) {
    case "visa":
      return "https://ensinio-public.s3.us-west-1.amazonaws.com/svg/visa.svg";

    case "mastercard":
      return "https://ensinio-public.s3-us-west-1.amazonaws.com/svg/mastercard.svg";

    case "hipercard":
      return "https://ensinio-public.s3-us-west-1.amazonaws.com/svg/hipercard.svg";

    case "elo":
      return "https://ensinio-public.s3-us-west-1.amazonaws.com/svg/elo.svg";

    case "amex":
      return "https://ensinio-public.s3.us-west-1.amazonaws.com/svg/american.svg";

    case "discover":
      return "https://ensinio-public.s3.us-west-1.amazonaws.com/svg/discover.svg";

    case "jcb":
      return "https://ensinio-public.s3.us-west-1.amazonaws.com/svg/jcb.svg";

    case "aura":
      return "https://ensinio-public.s3.us-west-1.amazonaws.com/svg/aura.svg";

    case "diners":
      return theme === "dark"
        ? "https://ensinio-public.s3.us-west-1.amazonaws.com/svg/dark-diners.svg"
        : "https://ensinio-public.s3.us-west-1.amazonaws.com/svg/white-diners.svg";

    default:
      return "https://ensinio-public.s3.us-west-1.amazonaws.com/svg/coringa.png";
  }
};
